import React, { useMemo } from 'react';
import SearchFilterPanel from './generic/SearchFilterPanels';
import SearchFiltersGroupHomeDetails from './SearchFiltersGroupHomeDetails';
import SearchFiltersGroupStatusAvail from './SearchFiltersGroupStatusAvail';
import SearchFiltersGroupPrice from './SearchFiltersGroupPrice';
import SearchFiltersGroupMore from './SearchFiltersGroupMore';
import { useCurrentRefinements, useRefinementList } from 'react-instantsearch-hooks-web';
import useSearchHasRefinement from '../hooks/useSearchHasRefinement';
import { Desktop } from '../../ui/Responsive';
import config from '../config/config';
import SearchSort from '../SearchSort';

const SearchFiltersDesktop = () => {
	const { items, canRefine, refine } = useCurrentRefinements();
	const {
		hasRefinementStatus,
		hasCurrentRefinementHomeDetails,
		hasCurrentRefinementPrice,
		hasRefinementMore,
	} = useSearchHasRefinement();

	// is this the best way to figure this out?
	// disable filter panel if there are no filters avaialble
	const { items: statuses } = useRefinementList( { attribute: config.FILTER_ATTRIBUTES.availability } );
	const { items: windows } = useRefinementList( { attribute: config.FILTER_ATTRIBUTES.moveInWindow } );
	const statusDisabled = useMemo( () => {
		return statuses.length === 0 && windows.length === 0;
	}, [ statuses, windows ] );

	const { items: tourOptions } = useRefinementList( { attribute: config.FILTER_ATTRIBUTES.tourOption } );
	const { items: types } = useRefinementList( { attribute: config.FILTER_ATTRIBUTES.neighborhoodType } );
	const { items: amenities } = useRefinementList( { attribute: config.FILTER_ATTRIBUTES.amenity } );
	const { items: districts } = useRefinementList( { attribute: config.FILTER_ATTRIBUTES.schoolDistrict } );
	const moreDisabled = useMemo( () => {
		return tourOptions.length === 0 && types.length === 0 && amenities.length === 0 && districts.length === 0;
	}, [ tourOptions, types, amenities, districts ] );

	return (
		<Desktop>
			<div className="tw-flex tw-justify-between tw-items-center">
				<div className="tw-py-4 tw-flex tw-space-x-2 xl:tw-space-x-8">
					<SearchFilterPanel isDisabled={statusDisabled} label="Status & Availability" hasRefinement={hasRefinementStatus}>
						<SearchFiltersGroupStatusAvail />
					</SearchFilterPanel>

					<SearchFilterPanel label="Home Details" hasRefinement={hasCurrentRefinementHomeDetails}>
						<SearchFiltersGroupHomeDetails />
					</SearchFilterPanel>

					<SearchFilterPanel label="Price Range" hasRefinement={hasCurrentRefinementPrice}>
						<SearchFiltersGroupPrice />
					</SearchFilterPanel>

					<SearchFilterPanel isDisabled={moreDisabled} label="More" position="right" hasRefinement={hasRefinementMore}>
						<SearchFiltersGroupMore />
					</SearchFilterPanel>
				</div>
				<div>
					<SearchSort />
				</div>
			</div>
		</Desktop>
	);
};

export default SearchFiltersDesktop;
